import axios from 'axios';
import { API_URL, CLOUDFLARE_TEST_ACCESS_TOKEN, CLOUDFLARE_TEST_ACCESS_SECRET } from './constants';
import * as Actions from 'actions/Authentication';
import { store } from 'reducers/createStore';

const defaultOptions = {
  baseURL: API_URL,
  method: 'get',
  headers: {
    'Content-Type': 'application/json',
    appPlatform: 'web',
    // 'CF-Access-Client-Id': CLOUDFLARE_TEST_ACCESS_TOKEN,
    // 'CF-Access-Client-Secret': CLOUDFLARE_TEST_ACCESS_SECRET
  },
};

const instance = axios.create(defaultOptions);

instance.interceptors.request.use((params) => {
  const config = { ...params };

  const { authToken } = store.getState().authentication;

  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }

  return config;
});

let isRefreshing = false;
let subscribers = [];

instance.interceptors.response.use(undefined, err => {
  const { config, response: { status, data } } = err;
  const originalRequest = config;
  const { token } = store.getState().authentication;

  // if (status === 401 && token) {
  //   if (!isRefreshing) {
  //     isRefreshing = true;
  //     store.dispatch(Actions.onCreateRequest(token, onRrefreshed));
  //   }
  //   const requestSubscribers = new Promise(resolve => {
  //     subscribeTokenRefresh(token => {
  //       originalRequest.headers.Authorization = `Bearer ${token}`;
  //       resolve(axios(originalRequest));
  //     });
  //   });
  //   return requestSubscribers;
  // }
  if (status === 401) {
    if (data?.body?.detailMessage === 'Expired or invalid JWT token') {
      console.log('Expired or invalid JWT token');
      // Handle token expiration
      if (window.location.pathname !== '/loggaut'&&window.location.pathname !== '/loggain') {
        store.dispatch(Actions.onResetRequest());
        window.location.href = '/loggaut';
      }
    }
  }

  return Promise.reject(err);
});

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed() {
  subscribers = [];
  isRefreshing = false;
}

export default instance;
